const state = {
  active: false,
  message: null
};

const actions = {
  success({ commit }, message) {
    commit("success", message);
  },
  error({ commit }, message) {
    commit("error", message);
  },
  clear({ commit }, message) {
    commit("success", message);
  }
};

const mutations = {
  success(state, message) {
    state.active = true;
    state.message = message;
  },
  error(state, message) {
    state.active = true;
    state.message = message;
  },
  clear(state) {
    state.active = false;
    state.message = null;
  }
};

export const alert = {
  namespaced: true,
  state,
  actions,
  mutations
};
